import '../scss/main.scss'; // IF we're in an iframe...

var isEmbedded = window.location !== window.parent.location; // You can write code specific to embeds like this...

if (isEmbedded) {
  window.childFrame.sendHeight();
} // Get the current locale: en, es, de, etc.
// const { lang } = document.documentElement;
// // ... use it to import text or data ...
// import(`Locales/${lang}/article/text.md`).then((text) => {
//   console.log(text.intro);
// });
//d3sl9l9bcxfb5q.cloudfront.net/json/your-spreadsheet-name


import Question from './question.svelte';
import { json } from 'd3-fetch';
var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
var id = urlParams.get('id') ? Number(urlParams.get('id')) : 0;
json('//d3sl9l9bcxfb5q.cloudfront.net/json/mm-tracing-poll').then(function (data) {
  new Question({
    target: document.querySelector('.container-question'),
    props: {
      data: data[id],
      id: id
    }
  });
});